<ada-container
	#MainContainer
	horizontalSpacing="Medium"
	id="MainContainer"
	verticalSpacing="Medium"
	colCount="{{ 4 }}"
	padding="0px {{ ui.Spacing.SPACING_LARGE }}"
>
	<ada-label content="Day Settings">
		<ada-text
			content="The Schedule will fire at the start time on the specified days of the week."
			data-container-selector="label-info-text"
		/>
	</ada-label>
	<ada-checkbox-group
		#DaysOfWeekCheckboxes
		id="DaysOfWeekCheckboxes"
		[ngModel]="selections()"
		[options]="dayOfWeekOptions"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsInline]="true"
		(ngModelChange)="updateSelections($event)"
	/>
</ada-container>
